export const MAX_FOLLOW_UP_COMMENT_LENGTH = 8000;

const FOLLOW_UP_COMMENT_SUPPORTED = new Set([
  "facebook",
  "instagram",
  "linkedin"
]);

export function supportsFollowUpComment(platform) {
  return FOLLOW_UP_COMMENT_SUPPORTED.has(String(platform || "").toLowerCase());
}

export function normalizeFacebookPostType(value) {
  const normalized = String(value || "post").toLowerCase();
  if (normalized === "reel" || normalized === "story") {
    return normalized;
  }
  return "post";
}

export function facebookPostTypeLabel(postType) {
  if (postType === "reel") return "Reel";
  if (postType === "story") return "Story";
  return "Feed";
}

export function facebookPostTypeRequiresVideo(postType) {
  return postType === "reel" || postType === "story";
}

export function followUpCommentPlatformsLabel() {
  return "Facebook Pages, Instagram Business, and LinkedIn";
}

export function contentHasVideo(mediaUrls = []) {
  return mediaUrls.some((url) => String(url).match(/\.(mp4|mov|webm)(\?.*)?$/i));
}

export function hasPendingVideoFiles(pendingFiles = []) {
  return pendingFiles.some((item) => item && item.file && !item.isImage);
}
